/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { forwardRef, useEffect, useLayoutEffect, useRef } from 'react';

import Quill from 'quill';
import "quill/dist/quill.snow.css";

const QuillEditor = forwardRef(
    ({ readOnly, defaultValue, onTextChange, onSelectionChange }: any, ref: any) => {
      const containerRef = useRef(null);
      const defaultValueRef = useRef(defaultValue);
      const onTextChangeRef = useRef(onTextChange);
      const onSelectionChangeRef = useRef(onSelectionChange);

      const toolbarOptions = [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        // [{ 'font': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        // [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['blockquote', 'code-block'],
        ['link', 'image'], // video removed
        ['clean']  // removes formatting
      ];

      const modules = {
        toolbar: toolbarOptions, // Using the toolbar options defined above
        clipboard: { matchVisual: false },
        // history: {
        //   delay: 2000,
        //   maxStack: 500,
        //   userOnly: true,
        // }
      };
  
      useLayoutEffect(() => {
        onTextChangeRef.current = onTextChange;
        onSelectionChangeRef.current = onSelectionChange;
      });
  
      useEffect(() => {
        ref.current?.enable(!readOnly);
      }, [ref, readOnly]);
  
      useEffect(() => {
        const container = containerRef.current;
        const editorContainer = container.appendChild(
          container.ownerDocument.createElement('div'),
        );
        const quill: any = new Quill(editorContainer, {
          theme: 'snow',
          modules: modules,
          placeholder: 'Compose an epic...',
        });
  
        ref.current = quill;
  
        if (defaultValueRef.current) {
          quill.root.innerHTML = defaultValueRef.current;
        }
  
        quill.on(Quill.events.TEXT_CHANGE, (...args) => {
          onTextChangeRef.current?.(...args);
        });
  
        quill.on(Quill.events.SELECTION_CHANGE, (...args) => {
          onSelectionChangeRef.current?.(...args);
        });
  
        return () => {
          ref.current = null;
          container.innerHTML = '';
        };
      }, [ref]);
  
      return <div ref={containerRef} style={{minHeight: "100px"}}></div>;
    },
);

export default QuillEditor;
